import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Pricing.css';

const services = [
  {
    name: 'Ceremony Package',
    description: 'Coverage of your wedding ceremony, group photos, and candid moments.',
    duration: '3 hr',
    price: '£399',
  },
  {
    name: 'Christening Photography',
    description: 'Capture your child\'s special day with beautiful baptism photos.',
    duration: '2 hr',
    price: '£299',
  },
  {
    name: 'Wedding Photography',
    description: 'Full day coverage, from getting ready to the last dance.',
    duration: '10 hr',
    price: '£899',
  },

  {
    name: 'Wedding Videography',
    description: 'Full day coverage, from getting ready to the last dance.',
    duration: '10 hr',
    price: '£899',
  },
  {
    name: 'Newborn Session',
    description: 'Gentle, natural photos of your newborn in a cozy setting.',
    duration: '2 hr',
    price: '£199',
  },
  {
    name: 'Real Estate Shoot',
    description: 'Professional photos to make your property stand out.',
    duration: '1.5 hr',
    price: '£100',
  },
  {
    name: 'Real Estate Walkthrough Video',
    description: 'Professional walkthrough video to make your property stand out.',
    duration: '1.5 hr',
    price: '£100',
  },
  
  {
    name: 'Car Photography',
    description: 'Striking photos for dealerships, showrooms, and private sellers.',
    duration: '0.5hr',
    price: '£89',
  },
  {
    name: 'Car Walkthrough Video',
    description: 'Walkthrough video focusing on the car and its features.',
    duration: '0.5hr',
    price: '£89',
  },
  {
    name: 'Car Combo Package',
    description: 'Combo package of car photography and walkthrough video.',
    duration: '1 hr',
    price: '£150',
  },
  {
    name: 'B2B Branding',
    description: 'Corporate headshots and branding images for your business.',
    duration: '2 hr',
    price: '£299',
  },
];

function Pricing() {
  return (
    <div className="pricing-section">
      <Helmet>
        <title>Photography & Videography Pricing - Szakacs Visuals</title>
        <meta name="description" content="View our photography and videography pricing packages. Professional services for weddings, portraits, real estate, and commercial photography in Bristol." />
        <meta name="keywords" content="photography pricing, wedding photography packages, portrait photography cost, Bristol photographer prices, South West UK photography rates" />
        <meta property="og:title" content="Photography & Videography Pricing - Szakacs Visuals" />
        <meta property="og:description" content="View our photography and videography pricing packages. Professional services for weddings, portraits, real estate, and commercial photography in Bristol." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/pricing" />
        <meta property="og:image" content="https://szakacsvisuals.co.uk/og-cover.jpg" />
        <meta property="og:image:alt" content="Szakacs Visuals Pricing" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/pricing" />
      </Helmet>
      <h1>Pricing</h1>
      <p>Explore our packages and pricing for all services.</p>
      <div className="pricing-list">
        {services.map((service, idx) => (
          <div className="pricing-list-card" key={idx}>
            <div className="pricing-list-header">
              <span className="pricing-list-title">{service.name}</span>
              <span className="pricing-list-price">{service.price}</span>
            </div>
            <div className="pricing-list-details">{service.description}</div>
            <div className="pricing-list-duration">{service.duration}</div>
          </div>
        ))}
      </div>
      <div className="pricing-cta">
        <p>Ready to book or have questions about a package?</p>
        <Link to="/contact" className="pricing-cta-btn">Contact Me</Link>
      </div>
    </div>
  );
}

export default Pricing; 